import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import AuthImage from "../../components/AuthImage";
import { createEditorialPlan } from "../editorial-analysis";
import { EditorialContent } from "../EditorialContent";
import { PostTitle } from "../PostTitle";

function AuthorAndTags({ plan }) {
  return (
    <>
      {plan.author?.name ? (
        <Typography
          component={RouterLink}
          to={`/?author=${encodeURIComponent(plan.author.name)}`}
          variant="body2"
          color="text.secondary"
          sx={{ mb: 1, display: "inline-block", textDecoration: "none", "&:hover": { color: "primary.main" } }}
        >
          {plan.author.name}
        </Typography>
      ) : null}
      {plan.tags?.length ? (
        <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap" sx={{ mb: 2 }}>
          {plan.tags.map((t) => (
            <Chip
              key={t}
              component={RouterLink}
              to={`/categories?tag=${encodeURIComponent(t)}`}
              clickable
              size="small"
              label={t}
              variant="outlined"
            />
          ))}
        </Stack>
      ) : null}
    </>
  );
}

export function FeaturePost({ post, onEdit }) {
  const plan = createEditorialPlan(post);
  const focus = plan.focus;
  const heroSrc = focus
    ? focus.public_url || `/media/${focus.media_uuid}`
    : null;

  return (
    <Box component="article" className="post post--feature" sx={{ py: { xs: 2, sm: 3 } }}>
      {heroSrc ? (
        <Box sx={{ mb: 2.5 }}>
          <AuthImage src={heroSrc} alt={plan.title} className="feature-hero__image" />
          {focus?.description ? (
            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.75 }}>
              {focus.description}
            </Typography>
          ) : null}
        </Box>
      ) : null}

      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5, flexWrap: "wrap" }}>
        {plan.isPrivate ? <Chip size="small" label="Privat" /> : null}
        {plan.visibility === "users" ? (
          <Chip size="small" label="Brugere" color="info" variant="outlined" />
        ) : null}
        {plan.dateLabel ? (
          <Typography variant="body2" color="text.secondary">
            {plan.dateLabel}
          </Typography>
        ) : null}
      </Box>
      <PostTitle title={plan.title} onEdit={onEdit} />
      <AuthorAndTags plan={plan} />

      <EditorialContent plan={plan} />
    </Box>
  );
}
